import client from './client';
import type {
  BulkCreateUsersRequest,
  BulkCreateUsersResponse,
  CreateUserRequest,
  CreateUserResponse,
  RegenerateOtpResponse,
  UserSummary,
} from '@/types';

/** GET /api/v1/users — every user, newest first. */
export async function listUsers() {
  const { data } = await client.get<UserSummary[]>('/users/');
  return data;
}

/** POST /api/v1/users — single create. Response includes the one-time OTP. */
export async function createUser(payload: CreateUserRequest) {
  const { data } = await client.post<CreateUserResponse>('/users/', payload);
  return data;
}

/** POST /api/v1/users/bulk — CSV import (email,name,role per row). */
export async function bulkCreateUsers(payload: BulkCreateUsersRequest) {
  const { data } = await client.post<BulkCreateUsersResponse>('/users/bulk', payload);
  return data;
}

/** POST /api/v1/users/{id}/reset-otp — generate a fresh OTP. */
export async function resetOtp(userId: string) {
  const { data } = await client.post<RegenerateOtpResponse>(`/users/${userId}/reset-otp`);
  return data;
}

/** POST /api/v1/users/{id}/set-active — enable/disable user. */
export async function setActive(userId: string, active: boolean) {
  const { data } = await client.post<UserSummary>(`/users/${userId}/set-active`, { active });
  return data;
}
